import React, { useMemo } from "react";
import { getSessionUser, isPlatformSuperAdmin, isCompanyAdmin } from "../../../utils/roleAccess";
import SuperAdminUsers from "./SuperAdminUsers";
import CompanyAdminUsers from "./CompanyAdminUsers";

function UsersPage() {
  const sessionUser = useMemo(() => getSessionUser(), []);
  if (isPlatformSuperAdmin(sessionUser?.role)) return <SuperAdminUsers />;
  if (isCompanyAdmin(sessionUser?.role)) return <CompanyAdminUsers />;
  return (
    <div className="m-5 bg-gx-border p-5 rounded-lg">
      <h3 className="text-xl font-bold text-center text-gx-ink-soft">
        Admin access required
      </h3>
    </div>
  );
}

export default UsersPage;
